export const checkIfShouldIndex = (host) => {
  if (host !== "www.obama.org") {
    const metaRobots = document.querySelector('meta[name="robots"]');
    metaRobots.setAttribute("content", "noindex,nofollow");
  }
};
